import { render, staticRenderFns } from "./RptSupplementCommodity.vue?vue&type=template&id=6663721a&"
import script from "./RptSupplementCommodity.vue?vue&type=script&lang=ts&"
export * from "./RptSupplementCommodity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports